import React, { useEffect } from 'react';
import Styles from  './styles.module.sass';
import { TarjetaSears } from 'newComponents/AgregarTarjetaSears'
import { useAddCard } from 'newHooks/useAddCard'
import { Error500 } from 'newComponents/Error/Error500'
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoGuestLayout from 'newComponents/Layout/CreditoGuestLayout';
import { useValidateAccount } from 'newHooks/useValidateAccount';
import SectionLayout from 'newComponents/Layout/SectionLayout';


export default function AgregarTarjeta() {

    const { addNewCard, errorCode} = useAddCard()
    const { flow, account, dataCard, showView } = useValidateAccount()

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Add Sears Card Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    return (
        <MainLayout>
            <CreditoGuestLayout flow={flow} hideMenu >
                <div className={Styles?.contTituloPage}>
                    <p className={Styles?.h1}>Registrar mi tarjeta Sears</p>
                    <p className={Styles?.subTitle}>Llena los siguientes datos tal cual aparecen en tu tarjeta.</p>
                    <SectionLayout >
                        <div className="contPlanes">
                            <TarjetaSears setAddCard={addNewCard} errorCode={errorCode}/>
                        </div>
                    </SectionLayout>
                </div>
            </CreditoGuestLayout>
        </MainLayout>
    )
}